// Static dial-code list for the phone field.
//
// Deliberately NOT libphonenumber-js (~145KB gzip with metadata): the initial-JS
// budget is 200KB gzip and we need exactly two things — a picker and a prefix.
// Nepal leads the list because it is the primary market (the institute-side
// copy has always used +9779812345678 as its example).
//
// Ordering is meaningful: the first entry after Nepal is India, then the rest
// alphabetically. Dial codes must be UNIQUE (see the +1 note below) — the
// derived DIALS_LONGEST_FIRST export gives splitE164 the longest-first matching
// it needs so "+977" wins over "+9".

export interface DialCode {
  /** ISO 3166-1 alpha-2, used as the option key. */
  iso: string;
  name: string;
  dial: string;
}

export const DEFAULT_DIAL = '+977';

export const DIAL_CODES: readonly DialCode[] = [
  { iso: 'NP', name: 'Nepal', dial: '+977' },
  { iso: 'IN', name: 'India', dial: '+91' },
  { iso: 'AU', name: 'Australia', dial: '+61' },
  { iso: 'BD', name: 'Bangladesh', dial: '+880' },
  { iso: 'BT', name: 'Bhutan', dial: '+975' },
  { iso: 'CN', name: 'China', dial: '+86' },
  { iso: 'DE', name: 'Germany', dial: '+49' },
  { iso: 'HK', name: 'Hong Kong', dial: '+852' },
  { iso: 'IE', name: 'Ireland', dial: '+353' },
  { iso: 'JP', name: 'Japan', dial: '+81' },
  { iso: 'KR', name: 'South Korea', dial: '+82' },
  { iso: 'KW', name: 'Kuwait', dial: '+965' },
  { iso: 'MY', name: 'Malaysia', dial: '+60' },
  { iso: 'NZ', name: 'New Zealand', dial: '+64' },
  { iso: 'OM', name: 'Oman', dial: '+968' },
  { iso: 'PK', name: 'Pakistan', dial: '+92' },
  { iso: 'PH', name: 'Philippines', dial: '+63' },
  { iso: 'PL', name: 'Poland', dial: '+48' },
  { iso: 'PT', name: 'Portugal', dial: '+351' },
  { iso: 'QA', name: 'Qatar', dial: '+974' },
  { iso: 'SA', name: 'Saudi Arabia', dial: '+966' },
  { iso: 'SG', name: 'Singapore', dial: '+65' },
  { iso: 'LK', name: 'Sri Lanka', dial: '+94' },
  { iso: 'AE', name: 'United Arab Emirates', dial: '+971' },
  { iso: 'GB', name: 'United Kingdom', dial: '+44' },
  // One entry, not two: a controlled <select value="+1"> matches the FIRST
  // option with that value, so separate "Canada" and "United States" rows would
  // make a US pick display as Canada.
  { iso: 'US', name: 'United States & Canada', dial: '+1' },
];

/**
 * Every distinct dial code, longest first — the order splitE164 needs so a
 * "+977" number is not mis-split as "+9" + "77…".
 */
export const DIALS_LONGEST_FIRST: readonly string[] = Array.from(
  new Set(DIAL_CODES.map((c) => c.dial)),
).sort((a, b) => b.length - a.length);
